(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cyc-carousel')) {
    customElements.define('cyc-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.tabs = [...this.querySelectorAll('[data-slide-to]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.stage = this.querySelector('.cyc-carousel__stage');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.userPaused = this.dataset.autoplay !== 'true' || this.dataset.editor === 'true';
        this.hovered = false;
        this.visible = true;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.go(this.index - 1, true), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true), { signal });
        this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.go(i, true), { signal }));
        this.toggle?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.update(); }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.update(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, { signal });
        this.addEventListener('focusin', () => this.update(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => this.update()), { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); }
        }, { signal });
        this.stage.addEventListener('pointerdown', event => { this.start = { x: event.clientX, y: event.clientY }; }, { signal });
        this.stage.addEventListener('pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) { this.swiped = true; this.go(this.index + (dx < 0 ? 1 : -1), true); setTimeout(() => { this.swiped = false; }, 300); }
        }, { signal });
        this.stage.addEventListener('pointercancel', () => { this.start = null; }, { signal });
        this.stage.addEventListener('click', event => { if (this.swiped) { event.preventDefault(); event.stopPropagation(); } }, { signal, capture: true });
        this.reduced.addEventListener('change', () => this.update(), { signal });
        document.addEventListener('visibilitychange', () => this.update(), { signal });
        document.addEventListener('shopify:block:select', event => { const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId); if (i >= 0) this.go(i, true); }, { signal });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); }, { threshold: .15 });
        this.observer.observe(this);
        this.go(0);
      }
      go(index, manual = false) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) this.userPaused = true;
        this.slides.forEach((slide, i) => { const active = i === this.index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        this.tabs.forEach((tab, i) => { if (i === this.index) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current'); });
        const nextImage = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        if (manual) this.querySelector('[data-slide-status]').textContent = this.slides[this.index].getAttribute('aria-label') + ': ' + this.slides[this.index].querySelector('.cyc-slide__heading').textContent;
        this.update();
      }
      update() {
        clearTimeout(this.timer);
        if (this.toggle) { this.toggle.hidden = this.reduced.matches || this.slides.length < 2; this.toggle.textContent = this.userPaused ? '▷' : 'Ⅱ'; this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel); }
        if (!this.isConnected || this.userPaused || this.reduced.matches || document.hidden || this.hovered || !this.visible || this.contains(document.activeElement) || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(5000, Number(this.dataset.delay) || 8000));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyc-product-shelf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cyc-product-rail')) {
    customElements.define('cyc-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-rail-viewport]');
        if (!this.viewport) return;
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.viewport.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); }, { signal, passive: true });
        this.viewport.addEventListener('keydown', event => { if (event.target === this.viewport && ['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); } }, { signal });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.viewport);
        this.update();
      }
      move(direction) {
        const card = this.viewport.querySelector('.cyc-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor((this.viewport.clientWidth + gap) / step));
        const rtl = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
        this.viewport.scrollBy({ left: direction * rtl * step * count, behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      update() {
        const position = Math.abs(this.viewport.scrollLeft);
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
